import React from 'react';
import BaseContent from 'components/BaseContent';
import { withRouter } from 'react-router-dom';

class App extends React.Component {
    render() {
        return (
            <BaseContent>
                这是应用配置页
            </BaseContent>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/pages/App/index.js